import { Card } from "@devhop/ui";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";

type ChecklistResultIncompleteItemsProps = {
  stats: ChecklistResultStatsResult;
};

export function ChecklistResultIncompleteItems({
  stats,
}: ChecklistResultIncompleteItemsProps) {
  if (stats.incompleteItemsTop.length === 0) return null;

  return (
    <Card className="gap-0 p-6">
      <h2 className="mb-4 font-semibold text-lg">
        ລາຍການທີ່ຍັງບໍ່ຕິກເມື່ອປິດບັນທຶກ (ສຳເລັດແຕ່ຍັງຂາດ)
      </h2>
      <div className="space-y-3">
        {stats.incompleteItemsTop.map((row, index) => (
          <div
            key={row.itemId}
            className="rounded-lg border p-4 hover:bg-muted/50"
          >
            <div className="flex items-start gap-2">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-500 font-bold text-white text-xs">
                {index + 1}
              </span>
              <div>
                <p className="font-medium">{row.title}</p>
                <p className="text-muted-foreground text-sm">
                  ພົບ {row.count} ຄັ້ງໃນຊ່ວງທີ່ເລືອກ
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
